import Cart from 'src/hooks/use-cart';
import User from 'src/hooks/use-user';
import { getComplianceConfig } from 'shared/core/helpers/compliance';
import type { GetRewardsV2Query } from 'src/gql/graphql';

export const getTermsOfUse = (dispensaryName: string, programName: string, dispensaryState?: string): string => {
  // Check if this is an Ohio dispensary and use Ohio-specific terms
  if (dispensaryState === 'OH') {
    const getOhioTerms = getComplianceConfig(dispensaryState, 'getComputedLoyaltyTermsOfUse');
    if (getOhioTerms) {
      return getOhioTerms(dispensaryName, programName);
    }
  }

  // Default terms for non-Ohio dispensaries
  return `I consent to signup for the ${dispensaryName} ${programName} program where I will receive marketing
        communications. By doing so, I understand that I am allowing ${dispensaryName} and its technology provider(s) to
        retain my personal contact details/engagement history for use in personalized marketing. Opt out at any time by
        replying "STOP" to messages. Standard message and calling rates may apply.`;
};

type SetLoyaltyDataProps = {
  user: ReturnType<typeof User>;
  cart: ReturnType<typeof Cart>;
  data: GetRewardsV2Query;
  dispensaryId: string;
  pin?: string;
};

export const setLoyaltyData = ({ user, cart, data, dispensaryId, pin }: SetLoyaltyDataProps): void => {
  const { getRewardsV2 } = data;

  if (getRewardsV2?.auth?.pinConfirmed && pin) {
    user.setLoyaltyPin(dispensaryId, pin);
  }

  user.hasLoyaltyAccount = true;
  user.isLoyaltyMember = getRewardsV2?.isLoyaltyMember;

  cart.availableRewards = getRewardsV2?.rewards.map((reward) => ({
    ...reward,
    brand: getRewardsV2.rewardBrand,
  }));
  cart.hasRewardsWallet = getRewardsV2?.userHasWallet;
  cart.rewardsBalance = getRewardsV2?.balance;
  cart.rewardBrandName = getRewardsV2?.rewardBrand;
  cart.rewardAuth = getRewardsV2?.auth;
  cart.hasCheckedForRewards = true;
};
